import React from 'react';
import { ReactComponent as FigUserPlus01Component } from './FigUserPlus01.svg';

const FigUserPlus01 = (props) => <FigUserPlus01Component {...props} />;

export default FigUserPlus01;
